import type {
  BOMRecipeItem,
  WorkOrderItem,
  QAInspectionItem,
  LotGenealogyRecord,
  WorkCenterSchedule,
  CostVarianceRow,
  MrpPlanRow,
} from './types';

export const sampleBOMs: BOMRecipeItem[] = [
  { id: '1', finished_sku_name: 'Helios Edge Rack Server 2U', labor_minutes: 45, standard_cost: 1350 },
  { id: '2', finished_sku_name: '100G QSFP28 Transceiver', labor_minutes: 15, standard_cost: 85 },
];

export const sampleWorkOrders: WorkOrderItem[] = [
  { id: '1', wo_number: 'WO-2026-0001', sku_name: 'Helios Edge Rack Server 2U', planned_qty: 10, actual_yield: 9, scrap_qty: 1, batch_number: 'BATCH-2026-M1', status: 'IN_PROGRESS', start_date: new Date().toISOString() },
  { id: '2', wo_number: 'WO-2026-0002', sku_name: '100G QSFP28 Transceiver', planned_qty: 50, actual_yield: 50, scrap_qty: 0, batch_number: 'BATCH-2026-M2', status: 'COMPLETED', start_date: new Date().toISOString() },
];

export const sampleQAs: QAInspectionItem[] = [
  { id: 'qa-1', inspector_id: 'Inspector #104', status: 'PASSED', notes: 'Dock receipt meets tolerance threshold <0.02mm', inspected_at: new Date().toISOString() },
  { id: 'qa-2', inspector_id: 'Inspector #108', status: 'PASSED', notes: 'Optical attenuation verified at 1310nm', inspected_at: new Date().toISOString() },
];

export const sampleGenealogy: LotGenealogyRecord[] = [
  { id: '1', batch_code: 'LOT-2026-X1', raw_material_lot: 'RM-OPT-99', work_order: 'WO-2026-0082', finished_lot: 'LOT-2026-X1', destination_shipment: 'SHP-2026-0312', status: 'SHIPPED' },
  { id: '2', batch_code: 'SRV-89021-US', raw_material_lot: 'RM-CHS-12', work_order: 'WO-2026-0081', finished_lot: 'SRV-89021-US', destination_shipment: 'Warehouse Central', status: 'IN_STOCK' },
];

export const sampleSchedules: WorkCenterSchedule[] = [
  { id: '1', center_name: 'Work Center 1 - Surface Mount Line', capacity_hours: 40, scheduled_hours: 36, utilization_pct: 90, active_wo: 'WO-2026-0081', status: 'OPTIMAL' },
  { id: '2', center_name: 'Work Center 2 - Cleanroom Assembly', capacity_hours: 40, scheduled_hours: 32, utilization_pct: 80, active_wo: 'WO-2026-0082', status: 'OPTIMAL' },
  { id: '3', center_name: 'Work Center 3 - Optical Burn-In & QA', capacity_hours: 40, scheduled_hours: 44, utilization_pct: 110, active_wo: 'WO-2026-0084', status: 'OVERLOAD' },
];

export const sampleCosting: CostVarianceRow[] = [
  { id: '1', wo_number: 'WO-2026-0081', product_name: 'Helios Edge Rack Server 2U', standard_cost: 1250.00, actual_cost: 1238.50, variance: -11.50, variance_pct: -0.9 },
  { id: '2', wo_number: 'WO-2026-0082', product_name: '100G QSFP28 Transceiver', standard_cost: 82.50, actual_cost: 84.10, variance: 1.60, variance_pct: 1.9 },
];

export const sampleMrp: MrpPlanRow[] = [
  { id: '1', sku: 'HL-OPT-100G', gross_requirement: 100, on_hand: 65, scheduled_receipts: 0, net_requirement: 35, action_type: 'PLANNED_PO', status: 'PLANNED' },
  { id: '2', sku: 'HL-SRV-2000', gross_requirement: 50, on_hand: 35, scheduled_receipts: 0, net_requirement: 15, action_type: 'PLANNED_WO', status: 'PLANNED' },
];

export function adaptBOM(raw: any): BOMRecipeItem {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), finished_sku_name: 'Untitled Assembly', labor_minutes: 0, standard_cost: 0 };
  }
  return {
    id: String(raw.id || Math.random()),
    finished_sku_name: String(raw.finished_sku_name || raw.name || 'Untitled Assembly'),
    labor_minutes: Number(raw.labor_minutes ?? 0),
    standard_cost: Number(raw.standard_cost ?? 0),
  };
}

export function adaptWorkOrder(raw: any): WorkOrderItem {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), wo_number: 'WO-0000', sku_name: 'Unknown', planned_qty: 0, actual_yield: 0, scrap_qty: 0, batch_number: '', status: 'SCHEDULED', start_date: new Date().toISOString() };
  }
  return {
    id: String(raw.id || Math.random()),
    wo_number: String(raw.wo_number || raw.number || 'WO-0000'),
    sku_name: String(raw.sku_name || raw.product_name || 'Unknown SKU'),
    planned_qty: Number(raw.planned_qty ?? 0),
    actual_yield: Number(raw.actual_yield ?? 0),
    scrap_qty: Number(raw.scrap_qty ?? 0),
    batch_number: String(raw.batch_number || ''),
    status: String(raw.status || 'SCHEDULED'),
    start_date: String(raw.start_date || new Date().toISOString()),
  };
}

export function adaptQA(raw: any): QAInspectionItem {
  if (!raw || typeof raw !== 'object') {
    return { id: Math.random().toString(), inspector_id: 'Unknown', status: 'PASSED', notes: '', inspected_at: new Date().toISOString() };
  }
  return {
    id: String(raw.id || Math.random()),
    grn_id: raw.grn_id ? String(raw.grn_id) : undefined,
    inspector_id: String(raw.inspector_id || 'Inspector'),
    status: String(raw.status || 'PASSED'),
    notes: String(raw.notes || ''),
    inspected_at: String(raw.inspected_at || new Date().toISOString()),
  };
}
